module.exports = __webpack_public_path__ + "cat.jpg?89f34365fa3b384baf39cdbedae79c1f";